import { Card, Stack, Box } from '@mui/material';
import { AI_AGENTS_INFO, AgentTypeWithFake } from './aiAgentsConsts';
import { colors, Typography, Button } from '@sweep-io/sweep-design';
import AgentTypeTag from './AgentTypeTag';
import { MouseEvent, useState } from 'react';
import SubscriptionRequiredDialog from './SubscriptionRequiredDialog';

const CreateNewAgentCard = ({
  agentType,
  onClick,
  opacity = 1,
  isNotSubscribed,
}: {
  agentType: AgentTypeWithFake;
  onClick?: (evt?: MouseEvent<HTMLDivElement>) => void;
  opacity?: number;
  isNotSubscribed?: boolean;
}) => {
  const { color, name, description, notSubscribedText } = AI_AGENTS_INFO[agentType];
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleCardClick = (evt?: MouseEvent<HTMLDivElement>) => {
    if (isNotSubscribed) {
      setIsDialogOpen(true);
    } else {
      onClick?.(evt);
    }
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <Card
        onClick={handleCardClick}
        sx={{ borderColor: colors.grey[300], overflow: 'visible', opacity }}
        elevation={0}
      >
        <Stack p={2} gap={2}>
          <AgentTypeTag size="big" color={color} text={name} />
          <Stack direction="row" justifyContent="space-between" alignItems="flex-end" gap={0.5}>
            <Typography variant="body" color={colors.grey[700]}>
              {description}
            </Typography>
            <Box
              sx={{
                whiteSpace: 'nowrap',
              }}
            >
              <Button
                variant="flat-blue"
                onClick={(evt) => {
                  evt.stopPropagation(); //prevent bubbling to the card
                  handleCardClick();
                }}
              >
                Launch agent
              </Button>
            </Box>
          </Stack>
        </Stack>
      </Card>

      {isNotSubscribed && (
        <SubscriptionRequiredDialog
          isOpen={isDialogOpen}
          onClose={handleCloseDialog}
          title={name + ' Agent'}
          text={notSubscribedText}
        />
      )}
    </>
  );
};

export default CreateNewAgentCard;
